import React, { Component } from 'react';
import axios from "axios";

import api from '../../../api/api';

import Modal from "./Modal"

import ParadigmaTable from "../../../components/ParadigmaTable/ParadigmaTable"

class Localidades extends Component {
    constructor() {
        super();
        this.state = {
            columns: [
                {
                    Header: "id",
                    id: "id",
                    accessor: "id",
                    width: 100,
                    show: false,
                    private: true,
                },
                {
                    Header: "Nombre",
                    id: "nombre",
                    accessor: d => d.nombre,
                    show: true,
                },
                {
                    Header: "Código Postal",
                    id: "codigoPostal",
                    accessor: d => d.codigoPostal,
                    show: true,
                },
                {
                    Header: "Provincia",
                    id: "provincia",
                    accessor: d => d.provincia.nombre,
                    show: true,
                },
            ]
        };
    }

    render() {
        const { data, pages, loading } = this.state;
        return (
            <ParadigmaTable
                buttons={[
                    {
                        create: true,
                        component: (props) => <Modal {...props} action="CREATE" />,
                        permission: 'geograficas_localidades_new',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="EDIT" />,
                        permission: 'geograficas_localidades_edit',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="DETAIL" />,
                        permission: 'geograficas_localidades_detail',
                    },
                    {
                        edit: true,
                        component: (props) => <Modal {...props} action="DELETE" />,
                        permission: 'geograficas_localidades_delete',
                    }
                ]}
                depth={1}
                apiUrl={api.geograficas.localidades}
                columns={this.state.columns}
                exportUrl={api.geograficas.localidades}
                title={"Localidades"}
            />
        );
    }
}

export default Localidades;



// WEBPACK FOOTER //
// ./src/views/Geograficas/Localidades/Localidades.js